const REPEAT_ARRAY_FORMAT_SEGMENTS = [
  "AssetStocks",
  "AssetStockBalances/export",

  "AssetUsageRecords",
  "AssetUsageRecords/count",
  "AssetUsageRecords/Statuses",
  "AssetUsageRecords/DownloadDocuments",
  "AssetUsageRecords/ForcedSendAssetUsageRecords",
  "ServerTime",
  "FarmLands/groupByCropType",
  "FarmLands/GetFarmLandGeometries",
  "FarmLands/SyncFarmLands",
  "FarmLands/DeleteGeometry",
  "MateriallyAccountableEmployees",
  "ObservationsV3",
  "ObservationsV3/FixPhenophase",
  "Report/dailyTotalReport",
  "Report/dailyTotalReport/send",
];

export const getSearchParamsArrayFormat = (url: string): "repeat" | "indices" => {
  const shouldUseRepeat = REPEAT_ARRAY_FORMAT_SEGMENTS.some((segment) =>
    url.includes(segment)
  );
  return shouldUseRepeat ? "repeat" : "indices";
};
